module.exports = __webpack_public_path__ + "img/homeOn.2f07fd88.svg";